var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#31373D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.936 13.402C10.8893 13.0287 10.9173 12.702 11.02 12.422C11.132 12.142 11.286 11.89 11.482 11.666C11.6873 11.442 11.9113 11.2367 12.154 11.05C12.406 10.8633 12.6393 10.6813 12.854 10.504C13.078 10.3267 13.26 10.1447 13.4 9.958C13.54 9.77133 13.61 9.566 13.61 9.342C13.61 9.062 13.54 8.824 13.4 8.628C13.26 8.432 13.0547 8.28267 12.784 8.18C12.5227 8.07733 12.2053 8.026 11.832 8.026C11.4027 8.026 11.0107 8.11933 10.656 8.306C10.3013 8.49267 9.95133 8.768 9.606 9.132L8.458 8.068C8.906 7.55467 9.43333 7.144 10.04 6.836C10.656 6.51867 11.3327 6.36 12.07 6.36C12.7513 6.36 13.3533 6.46267 13.876 6.668C14.408 6.87333 14.8233 7.186 15.122 7.606C15.43 8.01667 15.584 8.53467 15.584 9.16C15.584 9.50533 15.5093 9.80867 15.36 10.07C15.22 10.322 15.0333 10.5507 14.8 10.756C14.576 10.952 14.338 11.1433 14.086 11.33C13.834 11.5073 13.6007 11.694 13.386 11.89C13.1713 12.086 13.0033 12.3053 12.882 12.548C12.7607 12.7907 12.714 13.0753 12.742 13.402H10.936ZM11.846 17.126C11.4913 17.126 11.1973 17.0093 10.964 16.776C10.7307 16.5427 10.614 16.2487 10.614 15.894C10.614 15.53 10.7307 15.2313 10.964 14.998C11.1973 14.7647 11.4913 14.648 11.846 14.648C12.2007 14.648 12.4947 14.7647 12.728 14.998C12.9613 15.2313 13.078 15.53 13.078 15.894C13.078 16.2487 12.9613 16.5427 12.728 16.776C12.4947 17.0093 12.2007 17.126 11.846 17.126Z",
    fill: "#31373D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.91067298dff3ad6fc7e72d59bf92302f.svg";
export { ForwardRef as ReactComponent };